import React, { useState } from "react";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "./ui/collapsible";

const FAQ = () => {
  const [openItems, setOpenItems] = useState({});

  const toggleItem = (index) => {
    setOpenItems(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  const faqs = [
    {
      question: "Este livro é adequado para iniciantes na fé cristã?",
      answer: "Sim! 'A Vida de Jesus' foi escrito para pessoas em qualquer estágio de sua jornada espiritual. A narrativa é envolvente e acessível, permitindo que você compreenda os ensinamentos de Jesus mesmo que seja seu primeiro contato profundo com os evangelhos."
    },
    {
      question: "Como este livro é diferente de outros sobre Jesus?",
      answer: "Este livro oferece uma experiência única onde você se torna parte ativa da história. Ao invés de apenas ler sobre Jesus, você caminha ao lado d'Ele, testemunha Seus milagres e participa de cada momento como se fosse um discípulo."
    },
    {
      question: "Quanto tempo preciso para ler o livro completo?",
      answer: "O livro contém 41 capítulos transformadores. Você pode ler em seu próprio ritmo. Recomendamos dedicar pelo menos 15-20 minutos por dia para absorver completamente cada ensinamento e realizar as tarefas práticas."
    },
    {
      question: "As tarefas práticas são obrigatórias?",
      answer: "Não são obrigatórias, mas são altamente recomendadas. Cada capítulo termina com uma tarefa prática e pergunta reflexiva que ajudam você a aplicar os ensinamentos de Jesus em sua vida atual, maximizando a transformação."
    },
    {
      question: "O livro está disponível em formato digital?",
      answer: "Sim! O livro está disponível tanto em formato físico quanto digital (ebook). Você pode escolher a opção que melhor se adapta ao seu estilo de leitura."
    },
    {
      question: "Existe algum material complementar?",
      answer: "O livro é completo em si mesmo, mas incluímos tarefas práticas e perguntas reflexivas em cada capítulo para aprofundar sua experiência. Para dúvidas ou orientação adicional, você pode entrar em contato conosco via WhatsApp."
    },
    {
      question: "Posso presentear alguém com este livro?",
      answer: "Absolutamente! Este livro é um presente transformador para qualquer pessoa que busca crescimento espiritual, propósito de vida ou uma conexão mais profunda com Jesus Cristo."
    },
    {
      question: "Como posso entrar em contato para dúvidas?",
      answer: "Você pode entrar em contato conosco através do WhatsApp (21) 98640-2130. Estamos sempre disponíveis para esclarecer suas dúvidas sobre o livro ou sua jornada espiritual."
    },
    {
      question: "Existe garantia de satisfação?",
      answer: "Nossa maior garantia é a transformação que milhares de leitores já experimentaram. Se você ler o livro com coração aberto e aplicar os ensinamentos, sua vida será impactada pela presença de Jesus."
    },
    {
      question: "Este livro substitui a leitura da Bíblia?",
      answer: "Não, de forma alguma. Este livro complementa e enriquece sua leitura bíblica, oferecendo uma perspectiva unificada dos evangelhos. Recomendamos que continue estudando as Escrituras junto com esta obra."
    }
  ];

  return (
    <section className="py-20 px-6 bg-white">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-4xl font-bold text-gray-900 text-center mb-16">
          Perguntas Frequentes
        </h2>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <Collapsible
              key={index}
              open={openItems[index]}
              onOpenChange={() => toggleItem(index)}
              className="border border-gray-200 rounded-lg"
            >
              <CollapsibleTrigger className="w-full text-left p-6 hover:bg-gray-50 transition-colors">
                <div className="flex items-center justify-between">
                  <span className="font-semibold text-lg text-gray-900 pr-4">
                    {index + 1}. {faq.question}
                  </span>
                  <span className="text-2xl text-red-600 flex-shrink-0">
                    {openItems[index] ? '−' : '+'}
                  </span>
                </div>
              </CollapsibleTrigger>
              <CollapsibleContent className="px-6 pb-6">
                <p className="text-gray-700 leading-relaxed">{faq.answer}</p>
              </CollapsibleContent>
            </Collapsible>
          ))}
        </div>

        <div className="text-center mt-12">
          <p className="text-lg text-gray-600 mb-6">
            Ainda tem dúvidas? Entre em contato conosco!
          </p>
          <button
            onClick={() => {
              const message = encodeURIComponent("Olá! Tenho uma dúvida sobre o livro 'A Vida de Jesus: O Evangelho da Prosperidade Eterna'.");
              window.open(`https://wa.me/5521986402130?text=${message}`, '_blank');
            }}
            className="bg-green-600 hover:bg-green-700 text-white py-4 px-8 rounded-lg text-lg transition-colors"
          >
            📱 WhatsApp: (21) 98640-2130
          </button>
        </div>
      </div>
    </section>
  );
};

export default FAQ;